import { Axis } from './Axis.js';
import { AXIS_LABEL_HEIGHT, TOP_AXIS_LABEL_OFFSET } from './constants.js';
import { OrientedAxisProps } from './types.js';

/**
 * @internal
 */
export function AxisTop({
  scale,
  label,
  height,
  ...restAxisProps
}: OrientedAxisProps) {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const labelOffset = height! - AXIS_LABEL_HEIGHT - TOP_AXIS_LABEL_OFFSET;

  return (
    <Axis
      orientation="top"
      scale={scale}
      height={height}
      label={label}
      labelOffset={labelOffset}
      top={height}
      {...restAxisProps}
    />
  );
}

AxisTop['displayName'] = 'AxisTop';
